export default "__VITE_ASSET__Cx9kKoA2__"